(() => {
  const onReady = (fn) => {
    if (document.readyState === "complete" || document.readyState === "interactive") fn();
    else document.addEventListener("DOMContentLoaded", fn, { once: true });
  };

  const getSections = () => [...document.querySelectorAll("main#mainContent > .shopify-section")];

  const headerOffset = () => {
    const header =
      document.querySelector("sticky-header") ||
      document.querySelector("header") ||
      document.querySelector(".header-wrapper");

    if (!header) return 0;

    const st = getComputedStyle(header);
    const isStickyOrFixed = st.position === "sticky" || st.position === "fixed";
    return isStickyOrFixed ? Math.ceil(header.getBoundingClientRect().height) : 0;
  };

  const isMostlyInView = (el) => {
    const r = el.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    return r.top < vh * 0.25 && r.bottom > vh * 0.55;
  };

  const scrollToEl = (el) => {
    const LANDING_TWEAK_PX = 0;
    const top =
      el.getBoundingClientRect().top +
      window.pageYOffset -
      headerOffset() +
      LANDING_TWEAK_PX;

    window.scrollTo({ top, behavior: "smooth" });
  };

  const state = {
    bound: false,
    locked: false,
    hero: null,
    next: null,
  };

  const lock = (ms = 900) => {
    state.locked = true;
    setTimeout(() => (state.locked = false), ms);
  };

  const isHome = () =>
    document.body.classList.contains("t-index") ||
    document.body.classList.contains("t-home") ||
    !!document.querySelector("body.t-index");

  // Check desktop - ajuste le breakpoint selon ton thème (750px, 768px, 990px...)
  const isDesktop = () => window.matchMedia("(min-width: 768px)").matches;

  const snapIfHero = (e, directionDown) => {
    if (!isDesktop()) return false; // ← Désactive sur mobile/tablette
    if (!state.hero || !state.next) return false;
    if (state.locked) return false;
    if (!isMostlyInView(state.hero)) return false;
    if (!directionDown) return false;

    e.preventDefault();
    lock();
    scrollToEl(state.next);
    return true;
  };

  const bindListenersOnce = () => {
    if (state.bound) return;
    state.bound = true;

    // Desktop: wheel / trackpad
    window.addEventListener(
      "wheel",
      (e) => {
        snapIfHero(e, e.deltaY > 12);
      },
      { passive: false }
    );

    // Clavier: space / pagedown / flèche bas
    window.addEventListener(
      "keydown",
      (e) => {
        const downKeys = ["ArrowDown", "PageDown", " "];
        if (!downKeys.includes(e.key)) return;
        snapIfHero(e, true);
      },
      { passive: false }
    );

    // Mobile: swipe up (désactivé via isDesktop() dans snapIfHero)
    let startY = null;

    window.addEventListener(
      "touchstart",
      (e) => {
        if (!state.hero) return;
        if (!isMostlyInView(state.hero)) return;
        startY = e.touches[0].clientY;
      },
      { passive: true }
    );

    window.addEventListener(
      "touchmove",
      (e) => {
        if (startY == null) return;
        const dy = startY - e.touches[0].clientY;
        if (dy > 40) snapIfHero(e, true);
      },
      { passive: false }
    );
  };

  const init = () => {
    if (!isHome()) return;

    const sections = getSections();
    if (sections.length < 2) return;

    state.hero = sections[0];
    state.next = sections[1];

    bindListenersOnce();
  };

  onReady(() => {
    init();

    let tries = 0;
    const t = setInterval(() => {
      tries += 1;
      init();
      if (tries > 10) clearInterval(t);
    }, 300);
  });
})();